// @spec SHL-STR-016
// @spec SHL-STR-020
'use client';

import { Command } from 'cmdk';
import { Search } from 'lucide-react';

import { cn } from '@/lib/utils';

export interface SearchInputProps {
  /** Optional additional CSS classes */
  className?: string;
  /** Controlled input value */
  value?: string;
  /** Called when input value changes */
  onValueChange?: (value: string) => void;
  /** Placeholder text for the input */
  placeholder?: string;
}

/**
 * Styled search input for the global search dialog.
 *
 * Wraps cmdk's Command.Input with:
 * - Search icon on the left
 * - Escape key hint on the right
 * - Design system styling consistent with other inputs
 */
export function SearchInput({
  className,
  value,
  onValueChange,
  placeholder = 'Search...',
}: SearchInputProps) {
  return (
    <div className={cn('flex items-center border-b px-4', className)}>
      <Search className="mr-3 h-4 w-4 shrink-0 text-muted-foreground" />
      <Command.Input
        placeholder={placeholder}
        value={value ?? ''}
        {...(onValueChange && { onValueChange })}
        className="flex h-14 w-full bg-transparent text-base outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50"
      />
      <kbd className="pointer-events-none hidden select-none items-center gap-1 rounded border border-border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground sm:inline-flex">
        Esc
      </kbd>
    </div>
  );
}
